import CheckBox from "@Components/CheckBox";
import useTranslationHook from "hooks/useTranslationHook";
import { useEffect, useState } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

const CustomCheckBox = ({ label, onChange, isSelected, style = {} }: any) => {
  const { t } = useTranslationHook();
  const [selected, setSelected] = useState(isSelected);

  const toggleClick = () => {
    setSelected(!selected);
    onChange(!selected);
  };

  useEffect(() => setSelected(isSelected), [isSelected]);

  return (
    <div
      role="none"
      onClick={toggleClick}
      style={{ display: "flex", alignItems: "center", gridColumn: 12, ...style }}
    >
      <CheckBox isSelected={selected} />{" "}
      <div
        style={{ fontSize: 14, lineHeight: "20px", color: "#000", cursor: "default" }}
        data-testid={label}
      >
        {t(label)}
      </div>
    </div>
  );
};

export default wrapperHOC(CustomCheckBox, {
  componentName: "CustomCheckBox-BookForm",
  showForChina: true,
});
